import { createTheme, ThemeProvider } from "@mui/material/styles";

const AddDriverThemeProvider = ({ children }) => {
  const locale = window.localStorage.i18nextLng;

  const theme = createTheme({
    typography: {
      fontFamily: locale === "ar" ? "TheSansArab" : "Gellix",
    },
    palette: {
      primary: {
        main: "#6316DB",
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 999,
            fontWeight: "bold",
            textTransform: "none",
            padding: "10px 20px",
          },
        },
      },
    },
  });
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default AddDriverThemeProvider;
